import { Component, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DatatableService } from '../../services/datatable.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CancelServiceOption, CancelServicePayload, CancelServiceService, CancelType } from 'src/app/services/cancel-service.service';
import { finalize, take } from 'rxjs';
import { AlertService } from 'src/app/core/services/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cancel-modal',
  templateUrl: './cancel-modal.component.html',
  styleUrls: ['./cancel-modal.component.scss'],
})
export class CancelModalComponent {
  @Input() orderHash!: string;
  @Input() status!: number;

  form: FormGroup;

  reasons: CancelServiceOption[] = [];

  headerText: string | undefined;
  routesConfig = this.router.config;
  CancelLoading: boolean = false;
  reasonsLoading: boolean = false;

  otherReasonCode = 'OTHER_REASON';

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly dataService: DatatableService,
    private readonly bsModalService: BsModalService,
    private readonly cancelService: CancelServiceService,
    private readonly alertService: AlertService,
    private readonly translate: TranslateService

  ) {
    this.form = this.fb.group({
      causedBy: [CancelType.CLIENT, Validators.required],
      reasonCode: [null, Validators.required],
      percentage: [null],
    });
    this.loadReasons();
  }

  private loadReasons(): void {
    this.reasonsLoading = true;

    this.cancelService
      .getCancelReasons()
      .pipe(
        take(1),
        finalize(() => {
          this.reasonsLoading = false;
        })
      )
      .subscribe({
        next: (reasons: CancelServiceOption[]) => {
          this.reasons = this.filterReasons(reasons);
        },
        error: (error: unknown) => {
          console.error('[ModalCancelService] loadReasons error for', error);
          this.alertService.throwErrorMessage(
            this.translate.instant("CANCEL_SERVICE_MODAL.error_load_reasons")
          )
          this.reasons = [];
        },
      });
  }

  filterReasons(reasons: CancelServiceOption[] | null) {
    if (!reasons) { return [] }
    return reasons.filter((x) => { return x.code !== this.otherReasonCode })
  }

  cancelServiceRequest(): void {

    const { causedBy, reasonCode } = this.form.value;

    const payload: CancelServicePayload = {
      CancelType: causedBy,
      CancelReasonGuid: reasonCode,
      ReasonText: null,
      RefundType: undefined,
    };

    this.CancelLoading = true;

    this.cancelService
      .cancelService(this.orderHash, payload)
      .pipe(
        take(1),
        finalize(() => (this.CancelLoading = false))
      )
      .subscribe({
        next: () => {
          this.alertService.successMessage(
            this.translate.instant("CANCEL_SERVICE_MODAL.save_success")
          )
          this.bsModalService.hide('true');
        },
        error: (err: unknown) => {
          console.error('[ModalCancelService] save error', err);

          const status =
            err instanceof HttpErrorResponse ? err.status : undefined;

          let messageKey: string;
          if (status === 410) {
            // Transfer de larga distancia: no se puede cancelar dentro de las 24h previas al inicio
            messageKey = 'CANCEL_SERVICE_MODAL.save_error_410';
          } else if (status === 409) {
            // Resto de servicios: no se puede cancelar dentro de las 2h previas al inicio
            messageKey = 'CANCEL_SERVICE_MODAL.save_error_409';
          } else {
            messageKey = 'CANCEL_SERVICE_MODAL.save_error';
          }

          this.alertService.throwErrorMessage(
            this.translate.instant(messageKey)
          )
        },
      });

  }

  onClose(): void {
    this.bsModalService.hide();
  }
}
